<section
    [agprLoading]="loading"
>
    <div
        class="agpr-relatedConceptsToggle"
    >
        <agpr-button
            [id]="id + '_expandToggle_' + index"
            class="agpr-relatedConceptsToggleButton"
            [ngClass]="{'agpr-relatedConceptsToggleButton--disabled': !expandable}"
            (click)="togglePanel()"
            [disabled]="!expandable"
            [tooltip]="collapsed ? (expandable ? 'Core.expand' : 'Monitoring.relatedConcepts.expandToggle.disabled') : 'Core.collapse'"
        >
            <div class="agpr-button-customizedLabel">
                <i class="fa-kit fa-agpr-ai-analysis agpr-button-customizedLabel-icon"></i>
                <span>{{'RelatedConcepts.findConceptsButtonLabel' | localize }}</span>
            </div>
            <span [class]="collapsed ? 'fa-solid fa-angle-down' : 'fa-solid fa-angle-up'"></span>
        </agpr-button>
    </div>
    <div
        class="agpr-relatedConcepts"
        [ngClass]="{'agpr-relatedConcepts--expanded': !collapsed}"
        [@containerState]="collapsed ? 'hidden' : 'visible'"
    >
        <div
            *ngIf="concepts"
            class="agpr-relatedConcepts-conceptGroups"
        >
            <ng-container
                *ngTemplateOutlet="
                    group;
                    context {
                        key: 'themes',
                        header: 'RelatedConcepts.suggestThemes',
                        legend: 'RelatedConcepts.themes',
                        concepts: concepts.themes
                    }"
            ></ng-container>

            <ng-container
                *ngTemplateOutlet="
                    group;
                    context {
                        key: 'people',
                        header: 'RelatedConcepts.suggestPeople',
                        legend: 'RelatedConcepts.people',
                        concepts: concepts.people
                    }"
            ></ng-container>

            <ng-container
                *ngTemplateOutlet="
                    group;
                    context {
                        key: 'companies',
                        header: 'RelatedConcepts.suggestCompanies',
                        legend: 'RelatedConcepts.companies',
                        concepts: concepts.companies
                    }"
            ></ng-container>
        </div>
        <div class="agpr-relatedConcepts-footer">
            <agpr-button
                [id]="id + '_footer_refreshButton'"
                [style]="buttonTypes.tertiary"
                label="RelatedConcepts.refresh"
                [disabled]="disableReload"
                (click)="reload()"
            ></agpr-button>
            <agpr-button
                [id]="id + '_footer_addToMySearchButton'"
                [disabled]="disableConfirm"
                [style]="buttonTypes.tertiary"
                label="RelatedConcepts.addToMySearch"
                (click)="confirm()"
            ></agpr-button>
        </div>
    </div>
</section>


<ng-template
    #group
    let-key="key"
    let-header="header"
    let-legend="legend"
    let-concepts="concepts"
>
    <section
        class="agpr-relatedConceptsGroup"
    >
        <header class="u-srOnly">
        <h2>
            {{ header | localize }}
        </h2>
        </header>
        <div>
            <div>
                <div class="agpr-relatedConceptsGroup-header">
                    {{ legend | localize }}
                </div>
            </div>
            <div *ngIf="concepts" class="agpr-relatedConceptsGroup-container">
                <ul [attr.aria-label]="legend | localize">
                    <li
                        *ngFor="let concept of concepts; index as i"
                        class="agpr-relatedConceptsGroup-concept"
                    >
                        <agpr-checkbox
                            [id]="id + '_' + key + '_' + i"
                            [binary]="true"
                            [label]="concept.value"
                            [disabled]="concept.disabled"
                            [(ngModel)]="concept.selected"
                            (onChange)="setConfirmable()"
                        ></agpr-checkbox>
                        <agpr-dropdown
                            *ngIf="concept.selected && !concept.disabled"
                            [id]="id + '_' + key + '_dropdown_' + i"
                            class="agpr-relatedConceptsGroup-dropdown"
                            ariaLabel="RelatedConcepts.conjunctionLogic"
                            [bindToValue]="true"
                            [options]="operatorOptions"
                            [(ngModel)]="concept.type"
                        ></agpr-dropdown>
                    </li>
                </ul>
            </div>
        </div>
    </section>
</ng-template>
